// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToggleButtons-module__main--eeNxx {
    --button-padding-vertical: 10px;
    --button-padding-horizontal: 12px;
}

.ToggleButtons-module__button--R7dqD {
    --border-size: 1px;
    --border-radius: 12px;
    outline: none;
    border: var(--border-size) solid var(--color-primary);
    padding: calc(var(--button-padding-vertical) - var(--border-size))
        calc(var(--button-padding-horizontal) - var(--border-size));
    background-color: var(--color-general-white);
}

.ToggleButtons-module__button--R7dqD.ToggleButtons-module__selected--rl_jU {
    --border-size: 0px;
    background-color: var(--color-primary);
    color: var(--color-general-white);
}

.ToggleButtons-module__button--R7dqD:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
}

.ToggleButtons-module__button--R7dqD:last-child {
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
}

.ToggleButtons-module__button--R7dqD:hover {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/ToggleButtons/ToggleButtons.module.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,qDAAqD;IACrD;mEAC+D;IAC/D,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;IAC5C,+CAA+C;AACnD;;AAEA;IACI,6CAA6C;IAC7C,gDAAgD;AACpD;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".main {\n    --button-padding-vertical: 10px;\n    --button-padding-horizontal: 12px;\n}\n\n.button {\n    --border-size: 1px;\n    --border-radius: 12px;\n    outline: none;\n    border: var(--border-size) solid var(--color-primary);\n    padding: calc(var(--button-padding-vertical) - var(--border-size))\n        calc(var(--button-padding-horizontal) - var(--border-size));\n    background-color: var(--color-general-white);\n}\n\n.button.selected {\n    --border-size: 0px;\n    background-color: var(--color-primary);\n    color: var(--color-general-white);\n}\n\n.button:first-child {\n    border-top-left-radius: var(--border-radius);\n    border-bottom-left-radius: var(--border-radius);\n}\n\n.button:last-child {\n    border-top-right-radius: var(--border-radius);\n    border-bottom-right-radius: var(--border-radius);\n}\n\n.button:hover {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ToggleButtons-module__main--eeNxx`,
	"button": `ToggleButtons-module__button--R7dqD`,
	"selected": `ToggleButtons-module__selected--rl_jU`
};
export default ___CSS_LOADER_EXPORT___;
